'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleId$() {
  this.c8w = null;
  this.c8x = false;
}
export { $c_Lpresto_types$RoleId$ as $c_Lpresto_types$RoleId$ };
$p = $c_Lpresto_types$RoleId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleId$;
/** @constructor */
function $h_Lpresto_types$RoleId$() {
}
export { $h_Lpresto_types$RoleId$ as $h_Lpresto_types$RoleId$ };
$h_Lpresto_types$RoleId$.prototype = $p;
$p.nN = (function() {
  if ((!this.c8x)) {
    this.c8w = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.c8x = true;
  }
  return this.c8w;
});
var $d_Lpresto_types$RoleId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleId$, "presto.types$RoleId$", ({
  a1q: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleId$ as $d_Lpresto_types$RoleId$ };
var $n_Lpresto_types$RoleId$;
function $m_Lpresto_types$RoleId$() {
  if ((!$n_Lpresto_types$RoleId$)) {
    $n_Lpresto_types$RoleId$ = new $c_Lpresto_types$RoleId$();
  }
  return $n_Lpresto_types$RoleId$;
}
export { $m_Lpresto_types$RoleId$ as $m_Lpresto_types$RoleId$ };
//# sourceMappingURL=presto.types$-Role-Id$.js.map
